module.exports = __webpack_public_path__ + "static/media/ag-shop1Mobile.fed9c478.jpg";